import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { Constants } from "../../../utils/constants";
import { ContractsService } from "../../../services/contracts.service";
import { SnackService } from "../../../services/snack.service";
import { ApiResponse } from "../../../classes/api-response";
import { AuthService } from "../../../services/auth.service";
import { Box } from "../../../model/box";
import { BoxesService } from "../../../services/boxes-service";
import { PatchBox } from "../../../model/patch-box";

@Component({
  selector: 'aw-enable-box',
  templateUrl: './enable-box.component.html',
  styleUrls: ['./enable-box.component.scss']
})
export class EnableBoxComponent implements OnInit {

  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  @ViewChild('#enabling') enablingTemplate?: TemplateRef<any>;
  @ViewChild('#disabling') disablingTemplate?: TemplateRef<any>;
  saving = false;
  _box?: Box;
  generalError?: ApiResponse;
  public boxStatus = Constants.boxStatuses;
  public roles = Constants.roles;
  public currentStatus = this._box?.status;
  loggedUser: any;
  isBoxEnabled?= false;
  label2 = '';
  label3 = '';
  loadingTemplate?: TemplateRef<any>;


  constructor(
    public dialogRef: MatDialogRef<EnableBoxComponent>,
    private contractService: ContractsService,
    private boxesService: BoxesService,
    private authService: AuthService,
    private snackService: SnackService,
  ) {

    this.loggedUser = this.authService.loggedUser();


  }


  ngOnInit(): void {
    this.isBoxEnabled = this._box?.enabled;

    if (this.isBoxEnabled) {
      this.label2 = 'Disable box';
      this.label3 = 'Box disabled!';
      this.loadingTemplate = this.enablingTemplate;
    } else {
      this.label2 = 'Enable box';
      this.label3 = 'Box enabled!';
      this.loadingTemplate = this.disablingTemplate;
    }
  }

  @Input() set box(value: Box | undefined) {
    this._box = value;
  }

  enableOrDisable(): void {
    this.saving = true;
    const newBox = new PatchBox();
    newBox.enabled = !this._box?.enabled;

    this.boxesService.updateBox(newBox, this._box?.id)
      .subscribe(
        () => {
          this.saving = false;
          this.snackService.success(this.label3);
          this.dialogRef.close();
          this.saved.emit();
        },
        error => {
          this.saving = false;
          this.snackService.error(error.message);
          this.generalError = error;
        });
  }

}




